'use strict';

/**
 *
 * @name: nownessApp.addOns
 *
 */


/**
 *
 * -- DOCS --
 * Dont change addons name, is strictly depends on the class names from backend response.
 * To set addon, go to CMS > edit post > click ENGLISH/CHINESE tab > scroll to 'Content' WYSiWYG > here you can insert addons (YouTube, Quote, Vimeo, etc..)
 *
 */



import BrightcoveDirective from './nn-addon-brightcove/nn-addon-brightcove.directive';
import EcommerceDirective from './nn-addon-ecommerce/nn-addon-ecommerce.directive';
import QuotationDirective from './nn-addon-quotation/nn-addon-quotation.directive';
import SlideshowDirective from './nn-addon-slideshow/nn-addon-slideshow.directive';
import SoundcloudDirective from './nn-addon-soundcloud/nn-addon-soundcloud.directive';
import VimeoDirective from './nn-addon-vimeo/nn-addon-vimeo.directive';
import YoutubeDirective from './nn-addon-youtube/nn-addon-youtube.directive';

import StoryUserBoxDirective from './nn-story-user-box/nn-story-user-box.directive';
import CompileDirective from './nn-compile.directive';
import NnCompileWithCollapseDirective from './nn-compile-with-collapse.directive';

const AddOnsModule = angular
  .module('nownessApp.addOns', [])
  .directive('addonBrightcove', BrightcoveDirective)
  .directive('addonEcommerce', EcommerceDirective)
  .directive('addonQuotation', QuotationDirective)
  .directive('addonSlideshow', SlideshowDirective)
  .directive('addonSoundcloud', SoundcloudDirective)
  .directive('addonVimeo', VimeoDirective)
  .directive('addonYoutube', YoutubeDirective)
  .directive('storyUserBox', StoryUserBoxDirective)
  .directive('compile', CompileDirective)
  .directive('nnCompileWithCollapse', NnCompileWithCollapseDirective);

export default AddOnsModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-add-ons.module.js